<template>
  <div ref="editor" :class="clases" />
</template>

<script>
import Quill from 'quill';

export default {
  name: 'QuillEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    toolbarOptions: {
      type: Array,
      default: () => [
        [{header: [1, 2, false]}],
        ['bold', 'italic', 'underline'],
        [{'align': []}],
      ]
    },
    blockedWords: {
      type: Array,
      default: () => []
    },
    clases: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      quill: null
    };
  },
  watch: {
    value(newValue) {
      if (this.quill && newValue !== this.quill.root.innerHTML) {
        const delta = this.quill.clipboard.convert(newValue);
        this.quill.setContents(delta);
      }
    }
  },
  mounted() {
    this.quill = new Quill(this.$refs.editor, {
      theme: 'snow',
      modules: {
        toolbar: this.toolbarOptions
      }
    });

    if (this.value) {
      const delta = this.quill.clipboard.convert(this.value);
      this.quill.setContents(delta);
    }

    this.quill.on('text-change', (delta, oldDelta, source) => {
      let content = this.quill.root.innerHTML;
      this.blockedWords.forEach((word) => {
        const regExp = new RegExp(word, "g");

        if (!regExp.test(content)) {
          delta.ops.forEach((op) => {
            if (op.delete) {
              const restoredContent = oldDelta.ops
                  .map((o) => (o.insert ? o.insert : ''))
                  .join('');
              this.quill.root.innerHTML = restoredContent;
            }
          });
        }
      });

      this.$emit('input', this.quill.root.innerHTML);
    });
  },
};
</script>

<style lang="scss">
@import '~quill/dist/quill.snow.css';

.ql-editor {
  min-height: 80px;
}

.ql-toolbar.ql-snow {
    border: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #f1f1f1;
}

</style>
